/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

// Not customizable, the implementation has not been typed yet so its defined here.
type ToggleButtonForTogglableContentProps = {
  collapsed: boolean;
};

const ToggleButtonForTogglableContent = ({ collapsed }: ToggleButtonForTogglableContentProps) => {
  return (
    <Typography2 variant="subtitleMedium" component="span">
      {collapsed ? _t('Read more') : _t('Read less')}
    </Typography2>
  );
};

export default ToggleButtonForTogglableContent;
